
import TableList from "@components/templates/tablelist";
import compUpdate from "./update.vue";
import {
    HttpLimitOrgList
} from "@/service/setting.js";
import { mapState, mapGetters } from "vuex";
// import mixin from '../mixin';
export default {
    mixins: [TableList],
    components: {
        compUpdate,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    'EQ_status': null,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 100,
            },
            warehouseList: [],
            Plugins: { show: true },
            initData: '',
        };
    },
    methods: {
        ajaxRequest: HttpLimitOrgList,
        exportQuery() {
            let searchData = {}
            Object.keys(this.formData.search).map(item => {
                console.log(item, this.formData.search[item])
                searchData[`search[${item}]`] = this.formData.search[item]
            });
            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/carrierBlackList/batchExport", {
                ...searchData
            }, {
                executor: 'request',
                download: true,
            }).catch(err => {
                // this.$VMessage.error(err.message);
            })
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case 'exportQuery':
                    this.exportQuery(params)
                    break
                case 'add':
                    this.operate = {
                        title: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                        show: true,
                        width: 600,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'add',
                        showFooter: false
                    }
                    break;
                case 'edit':
                    this.operate = {
                        title: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                        show: true,
                        width: 600,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'edit',
                        showFooter: false
                    }
                    break;
                case 'changeStatus':
                    this.operate = {
                        title: params.status === 0 ? this.$t('fbb.accountmanage.loss_effect', { defaultValue: '失效' }) : this.$t('fbb.accountmanage.active', { defaultValue: '启用' }),
                        show: true,
                        alert: 'warning',
                        width: 400,
                        showDesc: true,
                        params: {
                            id: params.id
                        },
                        ajaxRequest: HttpBlackListActive,
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id } = row
            return [{
                label: this.$t('global.common.query', { defaultValue: '查看' }),
                show: this.handleAuth('fbb.blacklist.edit'),
                params: id,
                operate: 'query'
            }, {
                label: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                show: this.handleAuth('fbb.blacklist.edit'),
                params: {
                    id,
                    status: row.status
                },
                operate: 'edit'
            }]
        },
    },
    computed: {
        ...mapGetters("dictionary", [
            "getCarrierAll",
            "getBillcusWareList",
            "getSelfmanageorgList",
            "getAlllogProCodeList"
        ]),
        ToolsData() {
            return [
                {
                    name: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                    operate: "add",
                    show: this.handleAuth('fbb.blacklist.add'),
                    theme: "primary",
                },
                {
                    name: this.$t('fbb.alloment.muti_import', { defaultValue: '批量导入' }),
                    operate: 'exportQuery',
                    show: this.handleAuth('fbb.blacklist.export'),
                    theme: 'success'
                },
                {
                    name: this.$t('global.common.export', { defaultValue: '导出' }),
                    operate: 'exportQuery',
                    show: this.handleAuth('fbb.blacklist.export'),
                    theme: 'success'
                }
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                    key: 'IN_orgWarehouseCode',
                    show: true,
                    tag: 'Select',
                    options: this.getBillcusWareList.map(item => {
                        return {
                            label: item.label,
                            value: item.attach.code
                        }
                    }),
                    props: {
                        filterable: true,
                        clearable: true,
                        multiple: true
                    },
                },
                {
                    label: this.$t('erp.b2c.shipping_method', { defaultValue: '发货方式' }),
                    tag: 'Input',
                    key: 'CN_carrierServiceCode',
                }
            ]
        },
        columns() {
            return [
                {
                    // show: false,
                    type: 'index',
                    width: 40,
                    align: 'center',
                }, {
                    title: this.$t('global.common.actions', { defaultValue: '操作' }),
                    width: 70,
                    render: this.getOperateNodes,
                }, 
                {
                    title: this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                    key:'orgWarehouseCode'
                    // render: (h, { row }) => {
                    //     let warehouseItem = this.warehouseList.filter(item => {
                    //         return item.value === row.orgWarehouseId
                    //     })[0];
                    //     return <div>{warehouseItem ? warehouseItem.label : '--'}</div>
                    // }
                },
                {
                    title: this.$t('erp.b2c.shipping_method', { defaultValue: '发货方式' }),
                    key: 'updatedAt',
                },
                {
                    title: this.$t('', { defaultValue: '限额' }),
                    key: 'updatedAt',
                },
                {
                    title: this.$t('fbb.adjustment.created_name', { defaultValue: '创建人' }),
                    key: 'updatedAt',
                },
                {
                    title: this.$t('global.common.createdtime', { defaultValue: '创建时间' }),
                    key: 'updatedAt',
                }
            ];
        },

    }

};
